import styled from "styled-components";

export const Body1 = styled.span`
  ${props => ({ ...props.theme.font.body1 })}
  color: ${props => props.color || props.theme.colors.black};
`;
